import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { ButtonTypesEnum } from '@Common/Forms/enums/button-types.enum';
import { ViDimensionEnum } from '../../enums/vi-dimension.enum';

@Component({
    selector: 'agpr-vi-question-card',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './vi-question-card.component.html',
    styleUrls: ['./vi-question-card.component.scss'],
    standalone: false,
})
export class ViQuestionCardComponent {

    @Input() id: string = 'question';
    @Input({ required: true }) question!: string;

    @Input() hasError: boolean = false;
    @Input() allowDelete: boolean = true;
    @Input() selected: boolean = false;

    @Input() showDimention: boolean = false;
    @Input() dimension: ViDimensionEnum;
    @Input() showMetrics: boolean = false;
    @Input() score: number | null;
    @Input() delta: number | null;
    @Input() inverseArrows: boolean = false;

    @Output() selectChange = new EventEmitter<boolean>();
    @Output() deleteRequested = new EventEmitter<boolean>();

    readonly buttonType = ButtonTypesEnum;

    constructor() {}
}
